import { render } from "./SocialLinksSection.vue?vue&type=template&id=4f8b2c18&scoped=true"
const script = {}

import "./SocialLinksSection.vue?vue&type=style&index=0&id=4f8b2c18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f8b2c18"]])

export default __exports__